import { render, staticRenderFns } from "./MetacomDownloadModal.vue?vue&type=template&id=0b06a3c9&scoped=true&lang=pug"
import script from "./MetacomDownloadModal.vue?vue&type=script&lang=js"
export * from "./MetacomDownloadModal.vue?vue&type=script&lang=js"
import style0 from "./MetacomDownloadModal.vue?vue&type=style&index=0&id=0b06a3c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06a3c9",
  null
  
)

export default component.exports